import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-invoice-document',
  templateUrl: './invoice-documents.component.html',
  styleUrls: ['./invoice-documents.component.scss']
})
export class InvoiceDocumentsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
